module.exports = __webpack_public_path__ + "static/media/Vegan.382a1509.svg";